<template>
    <a-modal v-model="visible" title="成果申报详情" centered :maskClosable="false" :keyboard="false" width="75%">
        <a-spin :spinning="loading">
            <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="6">
                        <a-form-item label="成果名称">
                            <a-input ref="xmmc" v-model="editData.xmmc" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="专业名称">
                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果类型">
                            <a-input ref="cglx" v-model="editData.cglx" disabled />
                        </a-form-item>
                    </a-col>
                    <!--                    <a-col :span="6">
                        <a-form-item label="申报等级" hidden>
                            <a-input ref="cgsbdj" v-model="editData.cgsbdj" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="项目密级">
                            <a-input ref="xmmj" v-model="editData.xmmj" disabled />
                        </a-form-item>
                    </a-col>-->
                    <a-col :span="6">
                        <a-form-item label="成果开始时间">
                            <a-input ref="cgkssj" v-model="editData.cgkssj" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果完成时间">
                            <a-input ref="cgwcsj" v-model="editData.cgwcsj" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果预审结果">
                            <FGDictSelectCN ref="cgysjg" dictNo="ZJ200106" v-model="editData.cgysjg" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="所属分组">
                            <FGDictSelectCN ref="ssfz" dictNo="CG200102" v-model="editData.ssfz" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="否决原因">
                            <a-input ref="lxyy" v-model="editData.lxyy" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" :label="'其他主要  \n完成单位'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="qtzywcdw" v-model="editData.qtzywcdw" disabled :rows="1" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="内容提要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="nrty" v-model="editData.nrty" disabled :rows="10" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" :label="'成果特点及  \n申报理由'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="cgtdjsbly" :rows="10" v-model="editData.cgtdjsbly" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" :label="'审批(核准)  \n意见摘要'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="spyjzy" v-model="editData.spyjzy" disabled :rows="2" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" :label="'评估(评审、审查)  \n意见摘要'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="pgyjzy" :rows="2" v-model="editData.pgyjzy" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" :label="'评价、鉴定  \n意见摘要'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="pjjdyjzy" v-model="editData.pjjdyjzy" disabled :rows="2" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="其他摘要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="qtzy" :rows="2" v-model="editData.qtzy" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="申报单位意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="sbdwyj" v-model="editData.sbdwyj" disabled :rows="2" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <a-divider></a-divider>
            <a-tabs default-active-key="1" align="left">
                <a-tab-pane key="1" tab="成果相关附件">
                    <vxe-table
                        ref="ZLMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataZLMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                        <vxe-table-column field="zlmc" title="资料名称" width="300"></vxe-table-column>
                        <vxe-table-column field="bz" title="备注" min-width="100"></vxe-table-column>
                        <vxe-table-column title="附件" width="150" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="attachShow_zlmx(scope.row)">相关资料</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <a-tab-pane key="2" tab="成果获奖情况明细">
                    <vxe-table
                        ref="HJQKMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataHJQKMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                        <vxe-table-column field="hjsj" title="获奖时间" width="150" align="center"></vxe-table-column>
                        <vxe-table-column field="jlmc" title="奖励名称" width="300"></vxe-table-column>
                        <vxe-table-column field="jldj" title="等级" width="120" align="center"></vxe-table-column>
                        <vxe-table-column field="jjse" title="奖金数额(元)" width="110" header-align="center" align="right">
                            <template v-slot="{ row }">
                                <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="sjbm" title="授奖部门" min-width="100"></vxe-table-column>
                        <vxe-table-column title="附件" width="150" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="attachShow_hjqk(scope.row)">相关材料</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <a-tab-pane key="3" tab="成果主要完成人情况明细">
                    <vxe-table
                        ref="WCRMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataWCRMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                        <vxe-table-column field="xm" title="姓名" width="120" align="center"></vxe-table-column>
                        <vxe-table-column field="xb" title="性别" width="100" align="center"></vxe-table-column>
                        <vxe-table-column field="nl" title="年龄" width="100" align="center"></vxe-table-column>
                        <vxe-table-column field="zc" title="职称" width="200"></vxe-table-column>
                        <vxe-table-column field="gzdw" title="工作单位" min-width="100"></vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <!--                <a-tab-pane key="4" tab="成果申报打分明细">
                    <vxe-table
                        ref="DFMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataDFMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                        <vxe-table-column field="jcnr" title="合规审查内容" min-width="200"></vxe-table-column>
                        <vxe-table-column field="shjg" title="合规审查结果" width="150"></vxe-table-column>
                        <vxe-table-column field="shyj" title="合规审查意见" min-width="400"></vxe-table-column>
                    </vxe-table>
                </a-tab-pane>-->
            </a-tabs>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
        </template>
        <AttachModalDownload :attachCfg.sync="attachProps_zlmx" />
        <AttachModalDownload :attachCfg.sync="attachProps_hjqk" />
    </a-modal>
</template>

<script>
export default {
    name: "CgsbcxmxView",
    props: ["showCgsbcxmxView", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataZLMX: [],
            editItemDataZLMXLoading: false,
            editItemDataHJQKMX: [],
            editItemDataHJQKMXLoading: false,
            editItemDataWCRMX: [],
            editItemDataWCRMXLoading: false,
            editItemDataDFMX: [],
            editItemDataDFMXLoading: false,
            attachProps_zlmx: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_ZLMX",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            attachProps_hjqk: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            }
        };
    },
    computed: {
        // 是否显示编辑界面
        visible: {
            get() {
                return this.showCgsbcxmxView;
            },
            set(newVal) {
                this.$emit("update:showCgsbcxmxView", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/selectSbxmmxById",
                    {
                        id: this.cgsbbmxid
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载资料明细数据
                            this.loadItemDataZLMX();
                            // 加载获奖情况明细数据
                            this.loadItemDataHJQKMX();
                            // 加载完成人明细数据
                            this.loadItemDataWCRMX();
                            // 加载打分明细数据
                            // this.loadItemDataDFMX();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.visible = false;
                    }
                });
        },
        loadItemDataZLMX() {
            this.editItemDataZLMX = [];
            this.editItemDataZLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemZlmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZLMXLoading = false;
                    if (success) {
                        this.editItemDataZLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        loadItemDataHJQKMX() {
            this.editItemDataHJQKMX = [];
            this.editItemDataHJQKMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataHJQKMXLoading = false;
                    if (success) {
                        this.editItemDataHJQKMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        loadItemDataWCRMX() {
            this.editItemDataWCRMX = [];
            this.editItemDataWCRMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemWcrqkmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataWCRMXLoading = false;
                    if (success) {
                        this.editItemDataWCRMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        loadItemDataDFMX() {
            this.editItemDataDFMX = [];
            this.editItemDataDFMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemDFMX",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataDFMXLoading = false;
                    if (success) {
                        this.editItemDataDFMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        // 附件管理
        attachShow_zlmx(row) {
            // 设置编辑记录id
            this.attachProps_zlmx.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_zlmx.visible = true;
        },
        // 附件管理
        attachShow_hjqk(row) {
            // 设置编辑记录id
            this.attachProps_hjqk.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_hjqk.visible = true;
        }
    }
};
</script>
<style lang="scss" scoped></style>
